import { useCallback, useEffect, useRef, useState } from 'react';
import { measureRouteSpeed } from '../services/routeSpeedTest';

export default function useRouteSpeedTest(origins) {
  const requestRef = useRef(null);
  const [results, setResults] = useState({});
  const [completed, setCompleted] = useState(false);

  const cancel = useCallback(() => {
    requestRef.current?.abort();
    requestRef.current = null;
    setCompleted(false);
    setResults({});
  }, []);

  useEffect(() => () => {
    requestRef.current?.abort();
    requestRef.current = null;
  }, []);

  const start = useCallback(async () => {
    if (requestRef.current) return;
    const controller = new AbortController();
    requestRef.current = controller;
    setResults(Object.fromEntries(origins.map(origin => [origin, { status: 'testing' }])));
    setCompleted(false);
    await Promise.all(origins.map(async origin => {
      const result = await measureRouteSpeed(origin, controller.signal);
      if (requestRef.current !== controller || controller.signal.aborted) return;
      setResults(previous => ({ ...previous, [origin]: result }));
    }));
    if (requestRef.current !== controller || controller.signal.aborted) return;
    requestRef.current = null;
    setCompleted(true);
  }, [origins]);

  const measured = Object.entries(results).filter(([, result]) => result.status === 'success');
  const fastest = completed && measured.length > 1
    ? measured.reduce((best, entry) => entry[1].milliseconds < best[1].milliseconds ? entry : best)[0]
    : null;

  return { results, fastest, start, cancel };
}
